import React, { Component } from 'react';
import { connect } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import CallToAction from '../../components/common/CallToAction';
// import BlogCard from '../../components/common/BlogCard';
import Page from '../../components/Page';
// import MultiCarousel from '../../components/home/MultiCarousel';
import { FontAwesomeIcon } from '../../../node_modules/@fortawesome/react-fontawesome';
import { getBlogContent } from '../../actions/blog/index';
import _ from 'lodash';
// import { withRouter} from 'react-router-dom';
import moment from 'moment';
// import ReactPixel from 'react-facebook-pixel';
// import $ from 'jquery';
// import util from 'util';
import line_logo from '../../assets/img/beautrium/social_logo/line_logo.png';
import fb_logo from '../../assets/img/beautrium/social_logo/fb_logo.png';
import twitter_logo from '../../assets/img/beautrium/social_logo/twitter_logo.png';
import ShareSideBar from '../../components/common/ShareSideBar';
import { PUBLIC_URL } from '../../config';
import { blogShare } from '../../actions/blog/index';
import ProductCard from '../../components/product/ProductCard';
import ImageGallery from 'react-image-gallery';
import RelatedProductList from '../../views/blog/blog-render/RelatedProductList';
// import GoogleAds from '../../components/google/AdsInBlog';
import "react-image-gallery/styles/scss/image-gallery.scss";

// const ads_ids = ['6820398601', '3261277600', '4965200926', '8220891987', '1955894204', '4390485858', '1301110473', '2885832493', '4007342477', '1189607449'];
const frontLoad = async props => {
    // const blog_key = props.location.blog_key;
    const blog_url = props.match.params.id
    return await props.getBlogContent(blog_url);
};

class BlogContent extends Component {

    constructor(props) {
        super(props);

        this.fbShare = this.fbShare.bind(this);
        this.lineShare = this.lineShare.bind(this);
        this.twitterShare = this.twitterShare.bind(this);
        this.handleShare = this.handleShare.bind(this);
        this.renderPhotoByLayout = this.renderPhotoByLayout.bind(this)
    }

    componentDidMount() {
        // const advancedMatching = { em:  this.props.email}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
        // const options = {
        //     autoConfig: true, 	// set pixel's autoConfig
        //     debug: false, 		// enable logs
        // };
        // ReactPixel.init('2185933715027579', advancedMatching, options);
        // ReactPixel.track('ViewContent', {
        //     content_type: 'Blog',
        //     content_ids: this.props.location.blog_key,
        // });
        // (window.adsbygoogle = window.adsbygoogle || []).push({});
    }

    componentDidUpdate(prevProps) {
        //After user click share
        if (prevProps.share_result === null && this.props.share_result === true) {
            this.props.getBlogContent(this.props.location.blog_key)
        }
    }

    renderTag(tags) {
        return _.map(tags, (tag, index) => {
            if (index + 1 === tags.length) {
                return <span key={index}> {tag.tag_name} </span>
            } else {
                return <span key={index}> {tag.tag_name}, </span>
            }
        })
    }

    renderRelateProduct(products) {
        // console.log("RENDER RELATE PRODUCT", products)
        return _.map(products.data, (product, index) => {
            // console.log(product)
            return (
                <div key={index} className="col-6 col-md-3 col-xl-2">
                    <ProductCard item={product} />
                </div>
            )
            // return <span><a key ={index} href={`https://demo.thebeautrium.com/item/${product.mat_id}/${product.mat_var_id}`}> {product.mat_name}</a> ,</span>
        })
    }

    fbShare(url) {
        /* eslint-disable */
        FB.ui({
            method: 'share',
            href: url,
        }, function (response) { });
        /* eslint-enable */
        this.handleShare('fb_share', this.props.content.fb_share)
    }

    lineShare(url) {
        let temp = `https://social-plugins.line.me/lineit/share?url=${url}`
        window.open(temp, null, "width=503,height=510,left=50%,top=50%,resizable=yes,scrollbars=no,chrome=yes,centerscreen=yes")
        this.handleShare('line_share', this.props.content.line_share)
    }

    twitterShare(url, title) {
        // https://twitter.com/share?url=https://codepen.io/patrickkahl&amp;text=Share popup on &amp;hashtags=codepen
        let temp = `https://twitter.com/intent/tweet?text=${title + " " + url}&amp;hashtags=BEAUTRIUM`
        // let temp = `https://twitter.com/share?url=${url}&amp;text=${title}&amp;hashtags=BEAUTRIUM`
        window.open(temp, null, "width=503,height=510,left=50%,top=50%,resizable=yes,scrollbars=no,chrome=yes,centerscreen=yes")
        this.handleShare('twitter_share', this.props.content.twitter_share)
    }

    handleShare(platform, share) {
        this.props.blogShare(this.props.location.blog_key, platform, share, this.props.content.total_share)
    }

    renderPhotoByLayout(content) {
        const blog = this.props.content
        switch (content.layout) {
            case "STANDARD":
                return (
                    <div style={{ width: "100%" }}>
                        <img style={{ margin: "auto", display: "block", maxWidth: "100%" }} alt={blog.blog_title} src={content.content[0].imgUrl} />
                    </div>
                )
            case "BEFORE_AFTER":
                return (
                    <div style={{ display: "flex" }}>
                        <div className="content-image-holder" style={{ width: "49.5%", marginRight: "1%" }}>
                            <img className="content-image" alt={blog.blog_title} src={content.content[0].imgUrl} />
                        </div>
                        <div className="content-image-holder" style={{ width: "49.5%" }}>
                            <img className="content-image" alt={blog.blog_title} src={content.content[1].imgUrl} />
                        </div>
                    </div>
                )
            case "BIG_TOP_TWO_BOT":
                return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div style={{ paddingTop: "41.67%", position: "relative", marginBottom: "1%" }} >
                            <img className="content-image" alt={blog.blog_title} src={content.content[0].imgUrl} />
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ paddingTop: "41.67%", width: "49.5%", position: "relative", marginRight: "1%" }}>
                                <img className="content-image" alt={blog.blog_title} src={content.content[1].imgUrl} />
                            </div>
                            <div style={{ paddingTop: "41.67%", width: "49.5%", position: "relative" }}>
                                <img className="content-image" alt={blog.blog_title} src={content.content[2].imgUrl} />
                            </div>
                        </div>
                    </div>
                )
            case "BIG_LEFT_TWO_RIGHT":
                return (
                    <div style={{ display: "flex" }}>
                        <div style={{ width: "49.5%", height: "0", paddingTop: "83.334%", position: "relative", marginRight: "1%" }}>
                            {/* <div className="content-image-holder"> */}
                            <img className="content-image" alt={blog.blog_title} src={content.content[0].imgUrl} />
                            {/* </div> */}
                        </div>
                        <div style={{ width: "49.5%" }}>
                            <div style={{ width: "100%", paddingTop: "83.334%", position: "relative", marginBottom: "1.55%" }}>
                                <img className="content-image" alt={blog.blog_title} src={content.content[1].imgUrl} />
                            </div>
                            <div style={{ width: "100%", paddingTop: "83.334%", position: "relative" }}>
                                <img className="content-image" alt={blog.blog_title} src={content.content[2].imgUrl} />
                            </div>
                        </div>
                    </div>
                )
            case "FOUR_GRID":
                return (
                    <div style={{ display: "flex", flexWrap: "wrap" }} >
                        <div style={{ width: "49.5%", marginBottom: "1%", marginRight: "1%" }}>
                            <div style={{ width: "100%", position: "relative", paddingTop: "83.334%" }}>
                                <img className="content-image" alt={blog.blog_title} src={content.content[0].imgUrl} />
                            </div>
                        </div>
                        <div style={{ width: "49.5%", marginBottom: "1%" }}>
                            <div style={{ width: "100%", position: "relative", paddingTop: "83.334%" }}>
                                <img className="content-image" alt={blog.blog_title} src={content.content[1].imgUrl} />
                            </div>
                        </div>
                        <div style={{ width: "49.5%", marginRight: "1%" }}>
                            <div style={{ width: "100%", position: "relative", paddingTop: "83.334%" }}>
                                <img className="content-image" alt={blog.blog_title} src={content.content[2].imgUrl} />
                            </div>
                        </div>
                        <div style={{ width: "49.5%" }}>
                            <div style={{ width: "100%", position: "relative", paddingTop: "83.334%" }}>
                                <img className="content-image" alt={blog.blog_title} src={content.content[3].imgUrl} />
                            </div>
                        </div>
                    </div>
                )
            case "GALLERY":
                let gallery_content = _.map(content.content, (content) => {
                    return { original: content.imgUrl, thumbnail: content.imgUrl }
                })
                return (
                    <ImageGallery items={gallery_content} showPlayButton={false} showFullscreenButton={false} />
                )
            default:
                return null
        }
    }

    renderContentByType(content, index, adKey) {
        switch (content.type) {
            case "TEXT":
                return (
                    <div className="content-holder">
                        <div className="content"
                            dangerouslySetInnerHTML={{ __html: content.html }}
                        >
                        </div>
                    </div>
                )
            case "PHOTO":
                return (
                    <div className="content-holder">
                        <div className="content">
                            {this.renderPhotoByLayout(content)}
                        </div>
                    </div>
                )
            case "VIDEO":
                return (
                    <div className="content-holder">
                        <div className="content">
                            <div className="col-md-12">
                                <div className="blog-video-holder" style={{ position: "relative", paddingBottom: "56.25%", height: "0" }}>
                                    <iframe title="video" src={content.content} style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%" }} />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            case "RELATED_PRODUCT":
                return (
                    <div className="content-holder">
                        <div className="content">
                            <div className="d-flex nowrap-scroll products-scroll">
                                <RelatedProductList matVarId={content.content} />
                            </div>
                        </div>
                    </div>
                )
            // case "GG_ADS": 
            //     if (ads_ids[adKey] === '' || adKey >= ads_ids.length ) return null;
            //     return (
            //         <div className="content-holder">
            //             {this.renderAd(adKey)}
            //         </div>
            //     )
            // case "TIMELINE" :
            //     return (

            //     )
            // case "USER_REVIEW" :
            //     return (

            //     )
            default:
                return null
        }
    }

    renderBlogContent(arr_content) {
        let adIndex = 0;
        // const isAdSection = _.findIndex(arr_content, (content) => content.type === "GG_ADS") !== -1;
        return (
            _.map(arr_content, (content, index) => {
                // if (content.type === "GG_ADS") {
                //     adIndex += 1;
                // }
                return (
                    <React.Fragment key={`blog_${index}`}>
                        <div className="content-block mb-2">
                            {this.renderContentByType(content, index, adIndex - 1)}
                        </div>
                        {/* {(!isAdSection && (index === 2 || index === 8)) && this.renderAd(adIndex++)} */}
                    </React.Fragment>
                )
            })
        )
    }

    renderContent(legacy) {
        // const blog_id = this.props.location.blog_key;
        // this.props.getBlogContent(blog_id);
        // console.log("Fetched : " + util.inspect(this.props.content,0,true));
        const blog = this.props.content;
        // console.log("BLOG", blog)

        if (!blog) {
            return null;
        }
        const pathname = this.props.location.pathname
        let shareURL = PUBLIC_URL + pathname
        let encodeShareURL = encodeURIComponent(shareURL)
        const date = moment(blog.created_date).format("LLLL");
        // console.log (this.props.history);
        return (
            <div id="homepage" className="container blog-content" >
                {/* <div className="container blog-content"> */}
                {/* <ul className="bt-breadcrumb d-none d-xl-block border-bottom-1 border-lightgray pb-2">
                        <li><Link to="/">Home</Link><FontAwesomeIcon icon={["fal", "chevron-right"]} className="ml-2" /></li>
                        <li><Link to="/blogs">From BEAUTRIUM</Link><FontAwesomeIcon icon={["fal", "chevron-right"]} className="ml-2" /></li>
                        <li>{blog.blog_title}</li>
                    </ul> */}
                <div className="row">
                    <div onClick={this.props.history.length > 2 ? this.props.history.goBack : () => this.props.history.push(`/blogs`)} style={{ cursor: "pointer", marginLeft: "15px" }}>
                        <FontAwesomeIcon icon={["fal", "chevron-left"]} />&nbsp;Back
                    </div>
                </div>
                <div className="row content pt-2 mb-3">
                    <div className="col-12 mb-2">
                        <h1>{blog.blog_title}</h1>
                        <h4 className="color-light-gray">{![555, 4].includes(blog.user_id) ? blog.first_name + " " + blog.last_name + " | " : ""}{date}</h4>
                    </div>
                    <div className="col-md-3 offset-md-1 d-md-none mb-2">
                        <h4 className="color-light-gray" style={{ textAlign: "left", display: "inline-block" }}><FontAwesomeIcon icon={["fas", "share-alt"]} /> {blog.total_share} |
                        </h4>
                        <div style={{ display: "inline-block", marginLeft: "5px" }}>
                            <div style={{ display: "flex" }}>
                                <div className="social-logo-holder mobile">
                                    <img alt="facebook" src={fb_logo} style={{ width: "100%" }} onClick={(e) => { e.preventDefault(); this.fbShare(shareURL) }}></img>
                                </div>
                                <div className="social-logo-holder mobile">
                                    <img alt="twitter" src={twitter_logo} style={{ width: "100%" }} onClick={(e) => { e.preventDefault(); this.twitterShare(encodeShareURL, blog.blog_title) }}></img>
                                </div>
                                <div className="social-logo-holder mobile" onClick={(e) => { e.preventDefault(); this.lineShare(shareURL) }}>
                                    <img alt="line" src={line_logo} style={{ width: "100%" }}></img>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-5 blog-content-block">
                        <img alt={blog.blog_title} className="blog-cover mb-md-4 mb-2" src={blog.cover_image} />
                        {legacy ? (
                            <div dangerouslySetInnerHTML={{ __html: blog.content }}></div>
                        )
                            : (<div className="contents">
                                {this.renderBlogContent(blog.content)}
                            </div>
                            )}
                    </div>
                    <div className="blog-footer">
                        {blog.tags.length > 0 && <div className="col-12 mt-3 pb-3 border-bottom-1 border-lightgray">
                            <span className="bold color-black">Tags: </span>{this.renderTag(blog.tags)}
                        </div>}
                        {blog.relate_products && blog.relate_products.data.length > 0 && <div className="col-12 pb-3 pt-5">
                            <span className="bold color-black">Relate product: </span>
                            <div className="row pt-2 row nowrap-scroll products-scroll">
                                {this.renderRelateProduct(blog.relate_products)}
                            </div>
                        </div>}
                    </div>
                    {/* <div className="row">
                        <iframe src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&layout=button_count&size=large&mobile_iframe=true&appId=319426445469691&width=95&height=28" 
                        width="95" height="28" style={{border:"none",overflow:"hidden"}} scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
                        </div> */}

                </div>
                {/* <div className="row col-12 related pt-2 px-0 mx-0">
                        <h3 className="d-none d-lg-block bold">บทความที่เกี่ยวข้อง</h3>
                        <div className="row d-none d-lg-flex mt-3">
                            <div className="col-lg-3">
                                <BlogCard />
                            </div>
                            <div className="col-lg-3">
                                <BlogCard />
                            </div>
                            <div className="col-lg-3">
                                <BlogCard />
                            </div>
                            <div className="col-lg-3">
                                <BlogCard />
                            </div>
                        </div>
                        <div className="w-100 relate-slider d-flex d-lg-none">
                            <MultiCarousel responsiveSetting={[{breakpoint: 576, settings: {slidesToShow: 1, initialSlide: 0}}]}>
                                <BlogCard />
                                <BlogCard />
                                <BlogCard />
                            </MultiCarousel>
                            <MultiCarousel slidesToShow={1} responsiveSetting={[{breakpoint: 576, settings: {slidesToShow: 1}},{breakpoint: 767, settings: {slidesToShow: 1}}]}>
                                <div className="col-12">
                                    <BlogCard />
                                </div>
                                <div className="col-12">
                                    <BlogCard />
                                </div>
                                <div className="col-12">
                                    <BlogCard />
                                </div>
                                <div className="col-12">
                                    <BlogCard />
                                </div>
                            </MultiCarousel>
                        </div>
                    </div> */}
                <ShareSideBar blogTitle={blog.blog_title} fbShare={blog.fb_share} lineShare={blog.line_share} twitterShare={blog.twitter_share} totalShare={blog.total_share} blogUrl={this.props.location.blog_key} />
            </div>
        )
    }

    // renderAd(key) {
    //     return <div className="content-block mb-2" key={`ads_${key}`}><GoogleAds slot={ads_ids[key]} /></div>
    // }

    render() {
        const blog = this.props.content;
        if (!blog) return null
        let legacy = blog.render === "legacy" ? true : false
        let begin = null
        let end = null
        let textContent = ""
        if (legacy) {
            begin = blog.content.indexOf('<p>') + 3
            end = blog.content.substr(begin).indexOf("<")
            textContent = blog.content.substr(begin, end);
        } else {
            let index = _.findIndex(blog.content, (content) => {
                return content.type === "TEXT"
            })
            if (index >= 0) {
                textContent = blog.content[index].content
            } else {
                textContent = blog.blog_title
            }
        }
        return (
            <Page id="blog" title={blog.blog_title} image={blog.cover_image} imageType={blog.cover_image.substr(blog.cover_image.lastIndexOf('.' + 1))} description={textContent}>
                {/* <div dangerouslySetInnerHTML={{__html: `<script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7409983154364289" crossorigin="anonymous"></script>`}}></div> */}
                {this.renderContent(legacy)}
                {/* <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <ins className="adsbygoogle"
                                style={{ display: "block" }}
                                data-ad-client="ca-pub-7409983154364289"
                                data-ad-slot="2922705567"
                                data-ad-format="auto"
                                data-full-width-responsive="true"></ins>
                        </div>
                    </div>
                </div> */}
                <div className="container-fluid px-0" style={{ margin: "30px 0" }}>
                    <CallToAction />
                </div>
            </Page>
        );
    }
}

function mapStateToProps(state) {
    // console.log("state.blog.content" + util.inspect(state.blog.content, 0, true));
    return {
        content: state.blog.content,
        share_result: state.blog.shareBlogResult,
    }
}
export default connect(mapStateToProps, { getBlogContent, blogShare })(frontloadConnect(frontLoad, { noServerRender: false, onMount: true, onUpdate: false })(BlogContent))
// export default withRouter(connect(mapStateToProps, { getBlogContent })(frontloadConnect(frontLoad)(BlogContent)))

